import { Component, OnInit, Input, ViewChild, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { OrderModel, StatusDTO } from 'src/app/store/order/model';
import { OrderFacade } from 'src/app/store/order/facade';
import { DialogChangeOrderStatusComponent } from 'src/app/shared/dialogs/dialog-change-order-status/dialog-change-order-status.component';
import { AbstractOrderApiService } from 'src/app/core/services/abstract/abstract-order-api-service';
import { UserFacade } from 'src/app/store/user/facade';
import notify from 'devextreme/ui/notify';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { OrderConstants } from 'src/app/core/constants/order-constants';

@Component({
  selector: 'app-order-status',
  templateUrl: './order-status.component.html',
  styleUrls: ['./order-status.component.scss'],
  standalone: false,
})
export class OrderStatusComponent implements OnInit {
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);
  private orderApiService = inject(AbstractOrderApiService);
  private userFacade = inject(UserFacade);

  @Input() order: OrderModel;
  @Input() externalRate: number;
  @Input() externalNextStatusId: number;
  @ViewChild(DialogChangeOrderStatusComponent)
  dialogChangeOrderStatus: DialogChangeOrderStatusComponent;
  statuses$: Observable<StatusDTO[]>;

  public _orderStatuses = OrderStatusConstants.OrderStatuses;

  ngOnInit(): void {
    this.statuses$ = this.orderFacade.allowedStatuses$;

    this.statuses$.subscribe(statuses => {
      statuses?.forEach(status => {
        if (
          this.isCompleted(this.order.status.id) &&
          this.isConfirmed(status.id) &&
          OrderConstants.AllowedValuesOfEvaluation.includes(this.externalRate)
        ) {
          // External (from email by URL) evaluation
          this.changeStatus(OrderStatusConstants.OrderStatuses.Confirmed);
        } else if (this.order.status.id != status.id && this.externalNextStatusId && status.id === this.externalNextStatusId) {
          // External (from email by URL) changing statuses
          this.changeStatus(this.externalNextStatusId);
        }
      });
    });

    if (this.order && this.order.id) {
      this.orderFacade.loadAllowedStatuses(this.order.id);
    }
  }

  onStatusChangeClick($event) {
    let newStatusId = $event.itemData.id;

    if (this.order.status.id != newStatusId) {
      this.changeStatus(newStatusId);
    }
  }

  isConfirmed(statusId: number) {
    return OrderStatusConstants.isConfirmed(statusId);
  }

  isCompleted(statusId: number) {
    return OrderStatusConstants.isCompleted(statusId);
  }

  public isForApproval(statusId: number) {
    return OrderStatusConstants.isForApproval(statusId);
  }

  getButtonClass(status: StatusDTO): string {
    let buttonClass = 'btn btn-light';

    if (this.isCurrent(status)) {
      buttonClass = 'btn btn-disabled';
    }

    if (this.isConfirmed(status.id)) {
      buttonClass = 'btn btn-green';
    }

    if (OrderStatusConstants.isRequiresImprovement(status.id)) {
      buttonClass = 'btn btn-coral';
    }

    return buttonClass;
  }

  getStatusButtonText(status: StatusDTO): string {
    let statusName = status.name;
    if (this.isCurrent(status)) {
      this.translate.get('CURRENT').subscribe(value => {
        statusName += ` (${value})`;
      });
    }

    if (this.isConfirmed(status.id)) {
      this.translate.get('RATE').subscribe(value => {
        statusName = value;
      });
    }

    return statusName;
  }

  isCurrent(status: StatusDTO): boolean {
    return this.order.status.id === status.id;
  }

  onStatus(status: StatusDTO) {
    if (this.order.status.id != status.id) {
      this.changeStatus(status.id);
    }
  }

  public changeStatus(newStatusId: number) {
    this.userFacade.selected().subscribe(user => {
      if (user) {
        this.orderApiService.canSaveStatus(this.order.id, user.id, newStatusId).subscribe(x => {
          if (x.result == true) {
            if (this.dialogChangeOrderStatus) {
              this.dialogChangeOrderStatus.execute(this.order, newStatusId, this.externalRate).subscribe(result => {});
            } else {
              alert('DialogChangeOrderStatusComponent not found');
            }
          } else {
            this.translate.get('NOT_PERMISSION_FOR_CHANGE_STATUS').subscribe(value => {
              notify(value, 'error', 3000);
            });
          }
        });
      }
    });
  }
}
